import React, { useEffect, useMemo, useState } from 'react'
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from '../../components'
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from '../../components/NextUITable'
import { usePost, usePostMutateWithSuccess } from '../../api/reactQueryCustomHooks'
import { apiRoute, GetLoginCredentialDb, linksUrl } from '../../constants/enum'
import { faEdit, faPlus, faReceipt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { Button, Modal, ModalBody, ModalHeader, ModalContent, useDisclosure } from '@nextui-org/react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmBox from '../../components/ConfirmBox'
import { toast } from 'react-toastify'
import { resetDetailParams, setDetailParams, setNewEntry, setSaleOrderDetail } from '../../state/salesOrderEntrySlice'
import { calculateTotal } from '../../Utility/utility'
import { enum_Report_Type } from '../report/ReportUtility'
import ReportViewer from '../report/ReportViewer'


const SalesOrderMaster = () => {
    const {
        isOpen: isOpenModel,
        onOpen: onOpenModel,
        onOpenChange: onOpenModelChange
    } = useDisclosure()

    const { token, user } = useSelector((state) => state.auth)
    const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [itemToDelete, setItemToDelete] = useState("")
    //  const INITIAL_VISIBLE_COLUMNS = ["actions", "PartyName", "Ord_No", "Ord_Date"]
    const INITIAL_VISIBLE_COLUMNS = ["actions", "party", "item_desc", "qtyper", "BMETER", "status"]
    // const [data, setData] = useState([])

    const { data: orderDetail = [],
        mutate: getOrderDetail } = usePostMutateWithSuccess({
            url: apiRoute.transaction.salesOrderEntry.getOrderDetail,
            queryKey: "Sales Order Data Detail"
        })

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        dispatch(resetDetailParams())
    }, [])

    const { isPending, isError,
        //  data: EntryData = [],
        data = [],
        mutate: filterData } = usePost({
            url: apiRoute.transaction.salesOrderEntry.getOrderShow,
            queryKey: "Sales Order Data"
        })

    const exportColumns = [

        {
            name: "Party Name",
            uid: "party",
        },
        {
            name: "Quality",
            uid: "item_desc",
        },

        {
            name: "Qty.Type",
            uid: "qtyper",
            // type: COLUMN_TYPE.date
        },
        {
            name: "Pending",
            uid: "BMETER",
            // type: COLUMN_TYPE.date
        },
        {
            name: "Status",
            uid: "status",
            // type: COLUMN_TYPE.date
        }
    ]
    const totalPending = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "BMETER",
            }),
        [data])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center
        },

        {
            name: "Party Name",
            uid: "party",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },

        {
            name: "Quality",
            uid: "item_desc",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },

        {
            name: "Qty.Type",
            uid: "qtyper",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Pending",
            uid: "BMETER",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            type: COLUMN_TYPE.number,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalPending,
            },
        },
        {
            name: "Status",
            uid: "status",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
    ]



    const funLoadData = () => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                bill_type: "S",

            }
        })
    }
    //console.log(data)
    useEffect(() => {
        funLoadData()
    }, [])

    const reportModel = () => {
        return (
            <Modal
                isOpen={isOpenModel}
                onOpenChange={onOpenModelChange}
                size="md">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-row gap-1">
                                Sales Order Form
                            </ModalHeader>
                            <ModalBody>
                                <div className="flex flex-col">
                                    <ReportViewer props_ReportType={enum_Report_Type.SaleOrderForm} />
                                </div>
                            </ModalBody>
                        </>

                    )}
                </ModalContent>
            </Modal>
        )
    }

    let downloadDataFooter = {
        party: "", item_desc: "",
        qtytype: "",
        BMETER: "TOTAl: " + totalPending,
        status: ""
    }
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                let obj = {
                    compcode: String(row.compcode),
                    orderno: row.order_no,
                    billtype: 'S'//row.Bill_Type,
                }

                dispatch(setDetailParams(obj))
                dispatch(setNewEntry(false))
                navigate(linksUrl.transaction.salesOrderEntry.createOrderEntry)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToDelete({ order_no: row.order_no, comp_code: row.compcode, bill_type: 'S' })// row.Bill_Type })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#075985" icon={faReceipt} />,
            onClick: (row) => {
                let obj = {
                    token: token,
                    compcode: row.compcode,
                    orderno: row.order_no,
                    billtype: row?.bill_type || '',
                    db_user: GetLoginCredentialDb(user, yearId)
                }
                dispatch(setSaleOrderDetail(obj))
                onOpenModel();
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

    ]
    const onSuccessDelete = (data) => {
        setItemToDelete("")
        toast.success("Entry Deleted",
            { position: "top-center" })
        funLoadData();

    }
    const { mutate: FnDeleteEntry } = usePost({
        url: apiRoute.transaction.salesOrderEntry.deleteEntry,
        queryKey: "DeleteSalesOrderEntry",
        onSuccessTasks: onSuccessDelete,

    })

    const handleConfirmBox = (data) => {
        if (data) {
            FnDeleteEntry({
                data: {
                    comp_code: itemToDelete.comp_code,
                    order_no: itemToDelete.order_no,
                    bill_type: itemToDelete.bill_type
                }
            })
        }
    }

    const handleAddNew = () => {
        dispatch(resetDetailParams())
        navigate(linksUrl.transaction.salesOrderEntry.createOrderEntry)
    }
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (
        <div>
            {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer pageName='Sales Order Entry' breadcrumbs={["Master", "Sales Order Entry"]} >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                {reportModel()}
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    exportColumns={exportColumns}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    showAdvanceFilter={false}
                    downloadFileName='SalesOrder-list'
                    id="order_no"
                >
                </NextUITable>
            </MainContainer>
        </div>
    )
}

export default SalesOrderMaster